import { atom } from 'jotai';

import { TracingReportPageInfo, TracingReportPane } from './types';

export const tracingReportPageInfoState = atom<TracingReportPageInfo>({
  target: null,
  targetId: null,
  page: 1,
  totalPage: 1,
  perPage: 10,
});

export const tracingReportPaneState = atom<TracingReportPane>({
  tracingReportDraftId: null,
  patient: null,
});
